import { Component } from '@angular/core'
import { VODPlayerComponent } from '../../widgets/vod-player/vod-player.component'
import { ProjectCMSWidgetType, VODPlayerWidget } from 'htv-lib'

@Component({
  selector: 'app-vod',
  standalone: true,
  imports: [VODPlayerComponent],
  templateUrl: './vod.component.html',
  styleUrls: ['./vod.component.scss'],
})
export class VODComponent {
  vodplayerconfig: VODPlayerWidget = {
    type: ProjectCMSWidgetType.VOD_PLAYER,
    name: 'DefaultVODTV',
    width: 1920,
    height: 1080,
    x: 0,
    y: 0,
  }
}
